import {
  JoonColorExpanded,
  SPACING,
  WarningTriangleIcon,
  FlexBox,
  JoonUIColor,
  Typography,
} from "@joonapp/web-shared"

import useCurrentClient from "./hooks/useCurrentClient"

const TOSNotSignedHeader = () => {
  const { currentClientProfile } = useCurrentClient()

  const hasSignedTOS = currentClientProfile?.user.has_signed_tos

  if (!currentClientProfile || hasSignedTOS) return <></>

  return (
    <FlexBox
      style={{
        background: JoonColorExpanded.red100,
        padding: `${SPACING.space3} ${SPACING.space4}`,
      }}
      align="center"
      wrap={false}
      gap={SPACING.space2}
    >
      <WarningTriangleIcon color={JoonUIColor.semantic.alert} />
      <Typography variant="bodySmallBold" color={JoonUIColor.semantic.alert}>
        TOS is not yet signed!
      </Typography>
      <Typography variant="bodySmall" color={JoonUIColor.semantic.alert}>
        Please remind {currentClientProfile?.user.name} via email or sms to sign
        the Coaching Terms of Service.
      </Typography>
    </FlexBox>
  )
}

export default TOSNotSignedHeader
